import React from 'react';
import { Box } from '@common-fe/common-fe';

import { useInvestmentsHoldings } from '../hooks';

import InvestmentManagementDonut from './InvestmentManagementDonut';

interface Props {
  accountId: string;
  disabled?: boolean;
}
const InvestmentsManagementItem: React.FC<Props> = ({ accountId, disabled }) => {
  const { isInvestorAccountExists } = useInvestmentsHoldings(accountId);
  if (isInvestorAccountExists) {
    return (
      <Box
        style={{ flex: 1 }}
        round="container1Round"
        background="canvas"
        direction="row"
        align="center"
        height={{ min: '96px' }}
        border={{ size: 'small', color: 'border2' }}
      >
        <InvestmentManagementDonut disabled={disabled} accountId={accountId} />
      </Box>
    );
  }
  return null;
};
export default InvestmentsManagementItem;
